import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import LipSnakeBitePiercingImage from '../../Assets/Piercing Services/lip snake bite piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function LipSnakeBitePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Lip Snake Bite Piercing UAE | 300 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Lip Snake Bite Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Lip Snake Bite Piercing 300 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={LipSnakeBitePiercingImage} alt="Lip Snake Bite Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Lip Snake Bite Piercing</h3>

          <p>
            Make a bold and stylish statement with our professional lip snake bite piercing services in the UAE, available at an affordable price of 300 AED. Lip snake bite piercing is a popular and edgy double lip piercing style that features two symmetrical piercings placed on either side of the lower lip, creating the iconic “snake bite” look. This striking and fashionable piercing is perfect for individuals who want to express their personality with confidence and stand out with a modern, alternative aesthetic. Whether you prefer sleek studs for a clean finish or bold rings for a more dramatic appearance, our expert specialists ensure precise placement for a perfectly balanced and visually appealing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each lip snake bite piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Since this style involves two piercings, our experienced specialists use advanced techniques to reduce discomfort and complete the procedure quickly and efficiently while maintaining precision.
          </p>

          <p>
            Lip snake bite piercing is ideal for individuals who want a bold and expressive look that reflects their unique style. The symmetrical placement creates a strong visual impact, making it a favorite among those who enjoy statement piercings. It also pairs well with other facial piercings, allowing you to create a customized and edgy aesthetic. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your facial structure and desired look.
          </p>

          <p>
            The procedure is typically completed within a short time, making it convenient for clients with busy schedules. We provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process. Our goal is to deliver a safe, stylish, and comfortable experience from start to finish.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that lip piercings can feel intimidating, especially when getting multiple piercings, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your lip snake bite piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, oral hygiene practices, and precautions to avoid infection or irritation. Following proper aftercare ensures faster healing and helps maintain the health and appearance of your piercings.
          </p>

          <p>
            Our lip snake bite piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted lip snake bite piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a bold and edgy look effortlessly. Book your lip snake bite piercing appointment today and express your individuality with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Lip Snake Bite Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default LipSnakeBitePiercing;